import { AssetType } from '../../api/models/Shared.types';
import { VodDetailDataSource } from './vod/VodDetailDataSource';
import { BundleDetailDataSource } from './bundle/BundleDetailDataSource';
import { ProgramDetailDataSource } from './epg/ProgramDetailDataSource';
import { RecordingDetailDataSource } from './epg/RecordingDetailDataSource';
import { ScheduleDetailDataSource } from './epg/ScheduleDetailDataSource';
import { ChannelDetailDataSource } from './epg/ChannelDetailDataSource';
import { SeriesDetailDataSource } from './epg/SeriesDetailDataSource';
import { Backend } from '../../api/Backend';
import { DetailDataSource } from './DetailDataSource';

export function getDetailDataSource(backend: Backend, type: AssetType): DetailDataSource {
  switch (type) {
    case AssetType.VOD:
      return new VodDetailDataSource(backend);
    case AssetType.SERIES:
      return new SeriesDetailDataSource(backend);
    case AssetType.SCHEDULE:
      return new ScheduleDetailDataSource(backend);
    case AssetType.CHANNEL:
      return new ChannelDetailDataSource(backend);
    case AssetType.RECORDING:
      return new RecordingDetailDataSource(backend);
    case AssetType.PROGRAM:
      return new ProgramDetailDataSource(backend);
    case AssetType.BUNDLE:
      return new BundleDetailDataSource(backend);
    // case AssetType.ARTICLE:
    default:
      throw new Error('Unrecognized or unsupported AssetType');
  }
}
